<template>
  <div id="left-bar" v-if="pageHasLeftBar">
    <div class="adaptive-column-content">
      <component :is="this.$route.meta.leftBarComponent" />
    </div>
  </div>
</template>

<script>
  import DesktopCategories from '/src/blocks/DesktopCategories'
  import ConditionsLeftBar from '/src/blocks/ConditionsLeftBar'

  export default {
    name: 'LeftBar',
    components: {
      DesktopCategories,
      ConditionsLeftBar
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/LeftBar.vue